export default "__VITE_ASSET__CtowD21O__"